/// <amd-module name="VSSUI/Components/Image/Image" />
import * as React from "react";
import { css } from "VSSUI/Util";
import { IImageProps } from "./Image.Props";

export function Image(props: Readonly<IImageProps>): JSX.Element {
    const shouldContainImage: boolean = props.containImage || props.width !== undefined || props.height !== undefined;
    const classNameOnImg: boolean = props.width === undefined && props.height === undefined;

    const image = (
        <img
            alt={props.alt}
            className={css(classNameOnImg && props.className, "bolt-image flex-noshrink", shouldContainImage && "contain")}
            key={props.key}
            role={props.role}
            src={props.src}
        />
    );

    if (props.width || props.height) {
        return (
            <div className={css(!classNameOnImg && props.className, "bolt-image-wrapper")} style={{ width: props.width, height: props.height }}>
                {image}
            </div>
        );
    } else {
        return image;
    }
}
